import script from "./BusinessIdField.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessIdField.vue?vue&type=script&setup=true&lang=js"

import "./BusinessIdField.vue?vue&type=style&index=0&id=2b1215d6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b1215d6"]])

export default __exports__